let Backbone = require("backbone");
let MenuTagCollection = require("../collection/MenuTagCollection.js");
let DbRecorder = require("../recorder/DbRecorder.js");
let DiscountModel = require("./DiscountModel.js");

let main = function (Backbone, MenuTagCollection, DbRecorder, DiscountModel) {
    return Backbone.Model.extend({
        defaults: {
            paid: false,
            quantity: 0,
            refundQuantity: 0,
            unPaidRefundQuantity: 0,
            orderedQuantity: 0,
            price: 0,
            originalAmount: 0,
            priority: 0,
            hasRefund: false,
            shouldRefund: false,
            status: 'ToConfirm',
            dateCreated: new Date(),
            discount: null,
            orderStatus:"now"
        },

        initialize: function (options) {
            var self = this, quantity, orderedQuantity, refundQuantity;
            self.on("change:refundQuantity", function () {
                refundQuantity = self.get("refundQuantity");
                quantity = self.get("quantity");
                orderedQuantity = Math.max((quantity - refundQuantity), 0);
                self.set({orderedQuantity: orderedQuantity});
            });
            self.on("change:quantity", function () {
                refundQuantity = self.get("refundQuantity");
                quantity = self.get("quantity");
                orderedQuantity = Math.max((quantity - refundQuantity), 0);
                self.set({orderedQuantity: orderedQuantity});
            });
            quantity = options.quantity ? options.quantity : 0;
            refundQuantity = options.refundQuantity ? options.refundQuantity : 0;
            self.set({orderedQuantity: (quantity - refundQuantity)});
            if (options.discount) {
                self.set({discount: new DiscountModel(options.discount)});
                self._onDiscountChange();
            }
            self.on("change:discount", self._onDiscountChange, self);
            //将服务器返回的tags封装成为Collection
            if (options.tags) {
                self.set({tags: new MenuTagCollection(options.tags)});
            }

            if (($.isArray(options.packageItems) && options.packageItems.length > 0) || !$.isEmptyObject(options.packageItems)) {
                // var packageItems = {};
                // $.each(options.packageItems, function (key, item) {
                //     packageItems[item.id] = item
                // });
                self.set({packageItems: options.packageItems});
            } else {
                self.unset("packageItems")
            }
        },

        _onDiscountChange: function () {
            var self = this, discount = self.get("discount");
            var offDiscountAmount = 0;
            self.set("offDiscountAmount", 0);
            self.unset("discountedPrice");
            if (discount) {
                switch (discount.get("type")) {
                    case "Amount":
                        if (discount.get("uses") != null && discount.get("uses").length > 0) {
                            if (discount.canApplyTo(self.get("menuItem"))) {
                                self.set("offDiscountAmount", discount.get("off") > self.getAmount() ? self.getAmount() : discount.get("off"));
                            }
                        } else {
                            self.set("discountedPrice", self.get("price"));
                            self.set("offDiscountAmount", parseFloat(discount.get("off") > self.getAmount() ? self.getAmount() : discount.get("off")));
                        }
                        break;
                    case "Percentage":
                        if (discount.canApplyTo(self.get("menuItem"))) {
                            var discountedPrice = discount.calculateDiscountedPrice(self.get("price"));
                            self.set("discountedPrice", discountedPrice);
                            self.set("offDiscountAmount", parseFloat(((self.get('price') - discountedPrice) * self.get('orderedQuantity')).toFixed(2)));
                        }
                        break;
                    default:
                        break;
                }
            }
        },

        _unsetDiscount: function () {
            this.unset("discount");
        },
        setQuantity: function (quantity) {
            var paid = this.get("paid");
            if (paid) {
                throw "Cant modify paid bill item";
            }
            this.set({
                quantity: quantity,
                originalAmount: quantity * this.get('price')
            });
        },

        getQuantity: function () {
            return this.get("quantity");
        },

        refund: function (reason, refundQuantity) {  // /apiBill/refundBillItem
            this.set({
                "refundNote": reason,
                "refundQuantity": this.get("refundQuantity") + refundQuantity,
                "unPaidRefundQuantity": this.get("unPaidRefundQuantity") + this.get("paid") ? 0 : refundQuantity,
                "shouldRefund": true,
                "hasRefund": true,
                "shouldRefundQuantity": refundQuantity || this.get("quantity"),
            });
        },

        getOrderedQuantity: function () {
            return this.get("orderedQuantity");
        },

        getAmount: function () {
            var amount = (this.get("discountedPrice") >= 0 ? this.get("discountedPrice") : this.get("price")) * this.get("orderedQuantity");
            if (this.get("discount")) {
                var discount = DbRecorder.convert2JSON(this.get("discount"));
                if (discount.type == "Amount" && this.get("offDiscountAmount") > 0) {
                    amount -= this.get("offDiscountAmount");
                }
            }
            if (amount != this.get("amount")) {
                this.set("amount", amount);
            }
            return amount;
        },

        //获取餐品折后价
        getDiscountedAmount: function () {
            var discountedAmount = (this.get("discountedPrice") >= 0 ? this.get("discountedPrice") : this.get("price")) * this.get("orderedQuantity");
            if (discountedAmount != this.get("discountedAmount")) {
                this.set("discountedAmount", discountedAmount);
            }
            return discountedAmount;
        },

        //获取餐品折扣金额
        getOffDiscountedAmount: function () {
            return this.get("offDiscountAmount") ? this.get("offDiscountAmount") : 0;
        },
        //获取餐品原始折扣金额
        getOffDiscountedOriginalAmount: function () {
            return this.get("offDiscountOriginalAmount") ? this.get("offDiscountOriginalAmount") : 0;
        },
        //获取餐品减现金额
        getDiscountIsAmountTotal: function () {
            var discount = this.get('discount'), offDiscountAmount = 0;
            if (discount) {
                if (discount.get('type') == 'Amount') {
                    offDiscountAmount = this.get("offDiscountAmount") ? this.get("offDiscountAmount") : 0
                }
            }
            return offDiscountAmount;
        },
        getStatus: function () {
            return this.get("status");
        },

        setStatus: function (status) {
            return this.set({status: status});
        },

        confirm: function () {
            this.set({confirmedTime: new Date().getTime(), status: "Confirmed"});
        },

        getOriginalAmount: function () {
            return this.get("price") * this.get("quantity");
        },
        isUnConfirm: function () {
            return this.getStatus() == "ToConfirm";
        },
        isConfirmed: function () {
            return this.getStatus() != "ToConfirm" && !this.isPaid();
        },
        hasPaid: function () {
            return this.get("paid") || this.get("orderedQuantity") == 0;
        },
        isPaid: function () {
            return this.hasPaid();
        },
        isRefunded: function () {
            return this.get("shouldRefund") || this.get("hasRefund");
        },
        needPay: function () {
            return this.isConfirmed() && !this.hasPaid();
        }
    });
};

let exportedValue = main(Backbone, MenuTagCollection, DbRecorder, DiscountModel);
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/model/BillItemModel.js